<template>
  <v-container>
    <!-- <v-card
      color="#efefef"
      class="ma-0 mb-5"
    >
      <scelta-lenti
        :alive="$options.surname ==='JOY' && $options.name === `Step${step}`"
        :order="order"
        @lensComplete="lensComplete"
      />
    </v-card> -->

    <v-tabs
      v-if="order?.monsmo=='M' && clidata.anacli.gruppo==1"
      v-model="tab"
      color="red"
    >
      <v-tab
        href="#herzach"
        @click="order.lens={};steporder.typlens='herzach'"
      >
        HERZACH
      </v-tab>
      <v-spacer />
      <v-tab
        href="#other"
        @click="order.lens={};steporder.typlens='other'"
      >
        Altre Marche
      </v-tab>
    </v-tabs>

    <v-card
      :color="steporder.typlens==='herzach'?'#f0fff1':'#efefef'"
      class="ma-0 mb-5"
    >
      <scelta-lenti-grv
        v-if="order?.monsmo=='M' && tab ==='herzach' && (!steporder.typlens || steporder.typlens==='herzach')"
        :alive="$options.surname ==='JOY' && $options.name === `Step${step}`"
        :order="order"
        @lensComplete="lensComplete"
      />
      <scelta-lenti
        v-else
        :alive="$options.surname ==='JOY' && $options.name === `Step${step}`"
        :order="order"
        @lensComplete="lensComplete"
      />
    </v-card>

    <v-btn
      color="primary"
      :disabled="!formValidate"
      @click="nextStep"
    >
      Avanti
    </v-btn>
    <v-btn
      text
      @click="prevStep"
    >
      Indietro
    </v-btn>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import SceltaLenti from '../SceltaLenti.vue'
  import SceltaLentiGrv from '../SceltaLentiGrv.vue'
  // import engine from '@/plugins/engine'

  export default {
    name: 'Step2',
    surname: 'JOY',
    components: {
      SceltaLenti,
      SceltaLentiGrv,
    },
    props: {
      step: {
        type: Number,
        default: null,
      },
    },
    data () {
      return {
        tab: 'other',
        steporder: {},
        formValidate: false,
      }
    },
    computed: {
      ...mapState(['auth', 'order', 'clidata']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },

    },
    watch: {
      step (newVal, oldVal) {
        console.log('load', this.$options.name)
        this.initData(newVal)
      },
    },
    created () {
      // this.$store.watch(
      //   (state) => state.order,
      //   (newValue, oldValue) => {
      //     // console.log('Order changed  in step2 from', oldValue, 'to', newValue)
      //     if (newValue) {
      //       this.steporder = Object.assign({}, newValue)
      //     }
      //   },
      //   {
      //     deep: true, // Optional: Use this if you need to watch nested properties
      //   },
      // )
    },
    mounted () {
      console.log('mount', this.$options.name)
      this.initData(this.step)
    },
    destroyed () {

    },
    methods: {
      initData (stp) {
        if (this.$options.name === `Step${stp}`) {
          this.steporder = Object.assign({}, this.order)
          this.formValidate = !!this.steporder.lens
        }
        // set tab attivo
        if (this.clidata.anacli.gruppo === '1') {
          console.log('steporder.typlens', this.steporder.typlens)
          if (this.steporder.typlens) {
            this.tab = this.steporder.typlens
          } else {
            this.tab = 'herzach'
          }
        }
      },
      lensComplete (lens) {
        if (!lens) {
          this.formValidate = false
          return
        }
        console.log('lensComplete', lens)
        this.steporder.lens = JSON.parse(JSON.stringify(lens))
        this.formValidate = true
      },
      nextStep () {
        if (this.step > this.steporder.step) { this.steporder.step = this.step }
        this.$store.commit('setOrder', this.steporder)
        this.$emit('nextStep', this.step + 1)
      },
      prevStep () {
        // console.log('prevStep', this.steporder)
        this.$emit('prevStep', this.step)
      },
    },
  }
</script>
